import React, { useMemo } from 'react'

import NoOp from '../../utils/NoOp'
import links from '../../constants/links'
import { ProductEnum, QuotationDocument } from '../../generated/graphql'
import { useQuotation } from '../context'

import { Checkbox } from '@olino/design-system'
import { DocumentDownloadText } from './DocumentDownloadText'

interface Props {
  value?: boolean
  onChange?: (value: boolean) => unknown
  className?: string
}

export const CheckoutAgreement: React.FC<Props> = ({
  value = false,
  onChange = NoOp,
  className,
}) => {
  const { quotation } = useQuotation()

  const product = useMemo(() => quotation.details.products?.at(0), [quotation])

  if (!product) return null

  return (
    <>
      <div className={className}>
        <Checkbox value={value} onChange={onChange} />
        <div className="text-grey-400 [&_a]:underline">
          Vous reconnaissez avoir reçu, lu et accepté les{' '}
          <DocumentDownloadText
            name="Conditions générales"
            product={product}
            document={QuotationDocument.GeneralTerms}
          />
          , la{' '}
          <DocumentDownloadText
            name="fiche d'information IPID DAB"
            product={product}
            document={QuotationDocument.IpidDab}
          />
          , la{' '}
          <DocumentDownloadText
            name="fiche d'information IPID RC"
            product={product}
            document={QuotationDocument.IpidRc}
          />
          . Vous reconnaissez avoir pris connaissance et accepter respectivement{' '}
          <a target="_blank" rel="noreferrer" href="/politiqueConfidentialite">
            les politiques de confidentialité de Pilliot Assurances
          </a>
          , ainsi que{' '}
          <a target="_blank" rel="noreferrer" href="/cgu">
            les Conditions Générales de Pilliot Assurances
          </a>
          . En fournissant vos données de paiement et en confirmant ce paiement, vous autorisez
          Pilliot Assurances et Stripe, notre prestataire de services de paiement, à envoyer des
          instructions à votre banque pour débiter votre compte des montants indiqués.
        </div>
      </div>
    </>
  )
}
